export default __webpack_public_path__ + "static/media/9х16.2c9b4f39.jpg";